import * as React from "react";
const BasecampIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 57 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M44.08 24.66 39 20.72l-.92-.72-1.08-.84-7.5-5.82a1.613 1.613 0 0 0-1-.34 1.593 1.593 0 0 0-1 .34l-5.51 4.28-9.07 7.04a1.496 1.496 0 0 0-.59 1.01L10 43h18v-9.71a.294.294 0 0 1 .186-.27.29.29 0 0 1 .114-.02.303.303 0 0 1 .26.15L34 43h13l-2.33-17.33a1.496 1.496 0 0 0-.59-1.01Z"
}));
export default BasecampIcon;